module.exports = __webpack_public_path__ + "img/Gloeckchen.6ea70dae.png";